import React from 'react'
import ReactDOM from 'react-dom'
import AppModal from './components/modals/AppModal'
import { ThemeProvider } from '@maui/theme'
import { AuthContextProvider } from './AuthContextProvider'
import { DetailsTimelineChart } from './components/charts'
import {
  Drawer,
  LinearLineChart,
  IndicatorsTable,
  RangeSlider,
  UseRangeSlider,
  useDefaultColumn,
  useFilterTypes,
  useTable,
  useSortBy,
  usePagination,
  useFilters,
  FilterSortTable,
  useSort,
  SortingToggle,
  Grid,
  NewBadge,
  IconListGrid,
  RelevantReportingWidget,
  Timestamp,
} from './components/common'
import {
  AssociationDetailsView,
  GroupAssociationDetailsView,
  SummaryDetailsView,
  TargetsDetailsView,
  CampaignDetailsView,
  RecentActivityView,
  CveDetailsView,
  MalwareDetailsView,
  ServiceDetailsView,
  IndicatorDetailsView,
  VulnerabilityDetailsView,
  cveColorTheme,
  v2StringMap,
  v3StringMap
} from './components/details'
import { SearchResult, SearchResultPreview } from './components/shared'
import { openModal, closeModal } from './events'
import { AdaptedMATIApiProvider } from './MATIApiProvider'
import { fileDownloadHandler, getVirusTotalIndicatorLink } from './utilities'
import { normalizeCveReports } from './api/normalizers'

export const MatiSharedModals = () => {
  return (
    <AuthContextProvider>
      <AdaptedMATIApiProvider>
        <ThemeProvider theme='dark'>
          <AppModal/>
        </ThemeProvider>
      </AdaptedMATIApiProvider>
    </AuthContextProvider>
  )
}

export {
  CampaignDetailsView,
  SummaryDetailsView,
  AssociationDetailsView,
  GroupAssociationDetailsView,
  TargetsDetailsView,
  CveDetailsView,
  RecentActivityView,
  DetailsTimelineChart,
  Drawer,
  IndicatorDetailsView,
  LinearLineChart,
  IndicatorsTable,
  MalwareDetailsView,
  ServiceDetailsView,
  VulnerabilityDetailsView,
  RangeSlider,
  UseRangeSlider,
  SearchResult,
  SearchResultPreview,
  useDefaultColumn,
  useFilterTypes,
  useTable,
  useSortBy,
  usePagination,
  useFilters,
  FilterSortTable,
  cveColorTheme,
  v2StringMap,
  v3StringMap,
  openModal,
  closeModal,
  useSort,
  SortingToggle,
  fileDownloadHandler,
  NewBadge,
  Grid,
  IconListGrid,
  RelevantReportingWidget,
  Timestamp,
  normalizeCveReports,
  getVirusTotalIndicatorLink,
}

export * from './components/forms'

export * from './hooks'

export const init = () => {
  const el = document.createElement('div')
  el.id = 'modals'
  document.body.appendChild(el)
  ReactDOM.render(<MatiSharedModals />, el)
}
